// lib/env.ts — typed access to Vite public env (VITE_* only; never secrets).
interface ViteEnv {
  VITE_SUPABASE_URL?: string;
  VITE_SUPABASE_ANON_KEY?: string;
  VITE_SITE_URL?: string;
}

export interface PublicConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  siteUrl: string;
  /** Gateway base = Supabase Edge Functions endpoint. */
  gatewayUrl: string;
}

export function readConfig(env: ViteEnv): PublicConfig {
  const supabaseUrl = env.VITE_SUPABASE_URL ?? '';
  return {
    supabaseUrl,
    supabaseAnonKey: env.VITE_SUPABASE_ANON_KEY ?? '',
    siteUrl: env.VITE_SITE_URL ?? 'http://localhost:5173',
    gatewayUrl: supabaseUrl ? `${supabaseUrl.replace(/\/$/, '')}/functions/v1` : '/functions/v1',
  };
}

export const config: PublicConfig = readConfig((import.meta as unknown as { env: ViteEnv }).env);
